<template>
  <div>
    <!-- <logo :collapse="isCollapse" /> -->
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in roleMenu"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import Logo from './Logo'
import SidebarItem from './SidebarItem'
// import variables from './variables.scss'
/* Layout */
// import Layout from '@/layout'
export default {
  components: { SidebarItem },
  data() {
    return {
      roleMenu: [
        {
          path: '/releaseManagement',
          meta: {
            title: '发布管理',
            icon: 'icon-cloud_brief'
            // roles: ['ADMIN']
          },
          children: [
            {
              path: 'releaseCount',
              meta: {
                title: '发布统计',
                icon: 'icon-2001wuxing'
              }
            },
            {
              path: 'releaseConfig',
              meta: {
                title: '发布配置',
                icon: 'icon-2001wuxing'
              }
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['sidebar']),
    routes() {
      console.log(this.$router.options.routes)
      // debugger;

      return this.$router.options.routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      const variables = {
        menuText: '#bfcbd9',
        menuActiveText: '#409EFF',
        subMenuActiveText: '#f4f4f5', // https://github.com/ElemeFE/element/issues/12951
        menuBg: '#304156',
        menuHover: '#263445',
        subMenuBg: '#1f2d3d',
        subMenuHover: '#001528',
        sideBarWidth: '16%'
      }
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
<style>
a:-webkit-any-link{
  text-decoration:none;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/index.vue